import { Link, Navigate, useParams } from "react-router-dom";
import api from "../../services/api";
import { vhostV1 } from "../funcoes";
import Navbar from "../navbar/navbar";
import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import SweetAlert from "react-bootstrap-sweetalert";
import FooterBar from "../footer/footerBar";
import customizeScrollbar from "customsb";
import ModalProdutoFicha from "./modalProdutoFicha";
import BuscaVazaia from "../components/buscavazia/buscaVazia";
import './fichaTecnica.css'; 
import ModalProdutoFicha2 from "./modalProdutoFicha2";
import FichaTecnicaPDF from "../reports/fichaTecnica/fichatecnica";

function NovaFichaTecnica(){

  useEffect(() => {
    // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
    customizeScrollbar({
      scrollbarWidth: "10px",
      trackBackground: "#333",
      thumbBackground:
        "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
      thumbBorderRadius: "10px",
    });
  }, []);

    let config = {
        headers: {
          'Authorization': localStorage.getItem("token"),
          'Content-Type': 'application/json'
        },
        'timeout': 10000
      }
    
    const inputs = document.querySelectorAll("input, select");

    // Adicione um manipulador de eventos para o evento "keydown" em cada entrada ou select
    inputs.forEach(input => {
      input.addEventListener("keydown", e => {
        // Se a tecla pressionada for Enter
        if (e.key === "Enter") {
          e.preventDefault(); // evita que a tecla "Enter" envie um formulário, se aplicável

          // Obtenha o índice do elemento atual
          const currentIndex = Array.from(inputs).indexOf(e.target);
  
          // Mova o foco para o próximo elemento de entrada ou select
          const nextIndex = currentIndex + 1;
          if (nextIndex < inputs.length) {
            inputs[nextIndex].focus();
          }
        }
      });
    });

    const {cod} = useParams();
    const {tag} = useParams();

     const [componentes, setComponentes] = useState([]);
     const [descricaoComponente, setDescricaoComponente] = useState('');
     const [compraComponente, setCompraComponente] = useState(0);
     const [quantidade, setQuantidade] = useState('');
     const [unidadeComponente, setUnidadeComponente] = useState('UN');
     const [custo, setCusto] = useState(0);
     
  
     const [cod_produto,setCod_produto]     = useState('');
     const [descricao,setDescricao]         = useState('');
     const [cod_grupo,setCod_grupo]         = useState(0);
     const [unidade,setUnidade]             = useState('UN');
     const [venda,setVenda]                 = useState(0);
     const [vendaDefault,setVendaDefault]   = useState(0);
     const [ncm,setNcm]                     = useState('');
     const [sucesso,setSucesso]             = useState('N')
     const [mensagem, setMensagem]          = useState('');
     const [grupos,setGrupos]               = useState([]);
     const [compra,setCompra]               = useState(0);
     const [compraDefault,setCompraDefault] = useState(0);
     const [estoque,setEstoque]             = useState(0);
     const [adicionais,setAdicionais]       = useState(0);
     const [markup,setMarkup]               = useState(0);
     const [markupDefault,setMarkupDefalt]  = useState(0);
     const [vendaMarkup,setVendaMarkup]     = useState(0);
     const [localizacao,setLocalizacao]     = useState(0);
     const [erroValidacao, setErrovalidacao] = useState(false);
     const [msgErro, setmsgErro] = useState('');
     const [ingredientes, setIngredientes] = useState([]);
     const [preparo, setPreparo] = useState('');
     const [codigoProd, setCodigoProd] = useState('');
     const [isProdutoOpen, setIsProdutoOpen] = useState(false);
     const [isProdutoOpen2, setIsProdutoOpen2] = useState(false);
     const [calculaCusto, setCalculaCusto] = useState(false); 
     const [novoPreco, setNovoPreco] = useState(0);
     const [novaVenda, setNovaVenda] = useState(0);
     const [calculaVenda, setCalculaVenda] = useState(false);
     const [att, setAtt] = useState(false);
     const [confirmacao, setConfirmacao] = useState(false);
     const [confirmacaoId, setConfirmacaoId] = useState(0);

    
    
     
  
     const [buscaNcm,setBuscaNcm]= useState('');
     const [Ncms,setNcms]        = useState([]);
     const [sResult,setSresult]  = useState(0);
     const [verificaProd, setVerificaProd] = useState('1');
     const [lucroReal, setLucroReal] = useState(0);
     const [qtdProduzida, setQtdProduzida] = useState(0);

     useEffect(function(){
      setCusto(Number(compraComponente) * Number(quantidade));
     },[quantidade,compraComponente])

     const adicionarComponente = () => {
      if (descricaoComponente && codigoProd && quantidade) {
        setComponentes([
          ...componentes,
          {CODIGO: codigoProd , DESCRICAO: descricaoComponente.toLocaleUpperCase(), QUANTIDADE: Number(quantidade), COMPRACOMPONENTE: Number(compraComponente), CUSTOCOMPONENTE: Number(custo)}
        ]);
        setDescricaoComponente('');
        setCodigoProd('');
        setQuantidade('');
        setCompraComponente(0);
        setCusto(0);
      } else {
        setmsgErro('Todos os campos são obrigatórios');
        setErrovalidacao(true);
        
      }
    };

    
    function salvaFicha(){

      if(componentes.length < 1){
        setmsgErro('Componentes não podem estar vazio');
        setErrovalidacao(true);
        return
      } else{
    
      const sJson = {cod: cod_produto, componentes: componentes, modo: preparo, compra: Number(compraDefault), venda: Number(venda), markup: Number(markup), qtd_resultado: Number(qtdProduzida)};

      console.log(sJson);

      api.post(vhostV1('webcash/produto/inserir-ficha-tecnica'),sJson,config)
      .then(function (response){
        console.log(response);
        setSucesso('S');
        
      })
      .catch(function(error){
        setmsgErro(error);
        setErrovalidacao(true);
        console.log(error);
        
      })
      
    }};

     useEffect(function(){  
      
        api.post(vhostV1('webcash/produto/Pesquisa/'+cod), {
            loja: localStorage.getItem('loja'),
            empresa: 0        
          },config)
          .then(function (response) {
            console.log(response);
            
            
            
            if (response.data.result === 1){
             setCod_produto(response.data.dados[0].COD_PRODUTO);  
             setDescricao(response.data.dados[0].DESCRICAO);  
             setVenda(response.data.dados[0].VENDA);
             setMarkup(response.data.dados[0].MARKUP);
             
             setCod_grupo(response.data.dados[0].COD_GRUPO);  
             setCompra(response.data.dados[0].COMPRA);  
             setCompraDefault(response.data.dados[0].COMPRA);  
            
             setEstoque(response.data.dados[0].ESTOQUE);
              }
    
                                   
          });
    
          
      },[])


      function openModalProduto(){
        setIsProdutoOpen(true);
        
     }
  
     function closeModalProduto(){
          setIsProdutoOpen(false);
        
  
       
     }

     function openModalProduto2(){
      setIsProdutoOpen2(true);
      
   }

   function closeModalProduto2(){
        setIsProdutoOpen2(false);
      

     
   }

   function confirmaId(id){
    setConfirmacaoId(id);
    setConfirmacao(true);
   }

   
   
  
   function deletaComponente(e){
    console.log(cod_produto);
    console.log(e);
    
    
   
    setComponentes(componentes.filter((item) => item.CODIGO !== confirmacaoId));
   
    setConfirmacao(false);
    
   }

   function imprimeFicha(){
    const sJson = {cod: cod_produto, descricao: descricao, componentes: componentes, modo: preparo, compra: Number(compraDefault), venda: Number(venda), markup: Number(markup), lucro: Number(lucroReal), qtd_resultado: Number(qtdProduzida)};

    console.log(sJson);
    
    FichaTecnicaPDF(sJson);
   }



   useEffect( function(){
    setLucroReal((Number(venda) - Number(compraDefault)) / Number(compraDefault) * 100);
   },[venda, compraDefault ]);
  
   function abreCalculaCusto(){
    setNovoPreco(componentes.reduce((acc, item) => acc + Number(item.CUSTOCOMPONENTE), 0)/Number(qtdProduzida));
    console.log(novoPreco);
    
    setCalculaCusto(true);
   }

   function abreCalculaVenda(){
    setNovaVenda(Number(compraDefault)+(Number(compraDefault) * Number(markup) / 100));
    console.log(novaVenda);
    
    setCalculaVenda(true);
   }

   function fechaCalculaVenda(){
    setCalculaVenda(false);
   }

   function atualizaVenda(){
    setVenda(novaVenda);
    setCalculaVenda(false);
   }

   function fechaCalculaCusto(){
    setCalculaCusto(false);
   }

   function atualizaCompra(){
    setCompraDefault(novoPreco);
    setCalculaCusto(false);
   }



   
   

   useEffect(function(){
           console.log(cod_produto);
           console.log(cod);
           
           
           
           api.post(vhostV1('webcash/produto/fichas-detalhada/'+cod_produto),{},config)
           .then(function (response) {
                
             console.log(response);
             if(response.data.result === 1){
              setPreparo(response.data.dados.ficha[0].MODO_PREPARO);
              setQtdProduzida(response.data.dados.ficha[0].QTD_RESULTADO);
              setComponentes(response.data.dados.componentes);
             }
             
           }
          ).catch(function (error) {
           console.log(error);
           
          });
          },[cod_produto]);
    

    function buscaIten(){
        api.post(vhostV1('webcash/produto/retornaproduto/'+Number(cod_produto)), {
          loja: localStorage.getItem('loja'),
          empresa: 0         
        },config)
        .then(function (response) { 
          
         if(response && response.data && response.data.dados){
          setVerificaProd(response.data.dados[0].COD_PRODUTO);
          setCod_produto(response.data.dados[0].COD_PRODUTO);
          setDescricao(response.data.dados[0].DESCRICAO);
          setVenda(response.data.dados[0].VENDA);
          setCompraDefault(response.data.dados[0].COMPRA);
          console.log(response)
    
          
          
           }
         else{
           console.log("não busquei")
         }  
          
         })
        .catch(function (error) {
         
          console.log(error);
                  
        });
         };

         
         
         

    return <div className="conteiner-fluid titulo ">
       

      <ModalProdutoFicha isOpen={isProdutoOpen}
                 onRequestClose={closeModalProduto}
                 setCodProduto={setCodigoProd}
                 setDescricao={setDescricaoComponente}
                 setCompra={setCompraComponente}
                 titulo="pesquisa de Produto"
                 tipo_venda={""}
                 /> 
                  <ModalProdutoFicha2 isOpen={isProdutoOpen2}
                 onRequestClose={closeModalProduto2}
                 setCodProduto={setCod_produto}
                 setDescricao={setDescricao}
                 setCompra={setCompraDefault}
                 setVenda={setVenda}
                 setMarkup={setMarkup}
                 titulo="pesquisa de Produto"
                 tipo_venda={"4"}
                 /> 
    <Navbar/>
    <div className="offset-lg-1 col-lg-10">
          <div className="d-flex justify-content-between">
            <h2>Ficha Técnica: {descricao}</h2> 
            <button 
           id='botao-produto' 
           className="btn btn-danger btn-cli" 
           type="button"
           onClick={imprimeFicha}
             >
    <i className="bi bi-printer-fill"></i> Imprimir
  </button>
            </div>         
                            
          <hr />
           <div className="conteiner-fluid">
           <form id="table-servico" className="row tela" >
              
           <div className="col-2">
              <label htmlFor="inputQuantidadeComponente" className="form-label">CODIGO</label>
              <div className="input-group">
              <input
                type="text"
                value={cod_produto}
                onChange={(e) => setCod_produto(e.target.value)}
                className="form-control"
                id="inputQuantidadeComponente"
                tabIndex="3"
                onBlur={(e) => buscaIten(e.target.value)}
                readOnly
              />
               <button
                type="button"
                className="btn btn-primary "
                onClick={openModalProduto2}
                id="button-addon2"
                
              >
                <i className="bi bi-search"></i>
                
              </button>
              </div>
            </div>
              <div id="table-servico" className="col-3">
                  <label htmlFor="inputAddress" className="form-label">DESCRICAO</label>
                  <input type="text" value={descricao} onChange={(e)=> setDescricao(e.target.value)} className="form-control" id="inputDescricao" tabIndex="2" required autoComplete="off" readOnly/>
              </div>
              
             

              <div className="col-1">
                  <label htmlFor="inputAddress" className="form-label">COMPRA</label>
                  <NumericFormat className="form-control"
                                 id="inputCompra" 
                                 value={compraDefault.toLocaleString("pt-br", {style:"currency", currency:"BRL"})}
                                 tabIndex="8"
                                 allowLeadingZeros
                                 readOnly
                                 decimalSeparator=','
                                 thousandSeparator='.'
                                 decimalScale={2}
                                 prefix="R$ "
                                 onValueChange={(values,suorceInfo)=>{
                                   setCompra(values.value);
                                 }} 
                            />     
              </div>   

              <div className="col-1">
                  <label htmlFor="inputAddress" className="form-label">MARKUP</label>
                  <NumericFormat className="form-control"
                                 id="inputCompra" 
                                 value={markup.toLocaleString("pt-br", {style:"currency", currency:"BRL"})}
                                 tabIndex="8"
                                 allowLeadingZeros
                                 decimalSeparator=','
                                 thousandSeparator='.'                                 
                                 suffix="%"
                                 onValueChange={(values,suorceInfo)=>{
                                   setMarkup(values.value);
                                 }} 
                            />     
              </div>
                 
              


                   

                                   

              <div className="col-1">
                  <label htmlFor="inputAddress" className="form-label">VENDA</label>
                  <NumericFormat className="form-control"
                                 id="inputCompra" 
                                 value={venda.toLocaleString("pt-br", {style:"currency", currency:"BRL"})}
                                 tabIndex="8"
                                 allowLeadingZeros
                                 decimalSeparator=','
                                 thousandSeparator='.'
                                 decimalScale={2}
                                 prefix="R$ "
                                 onValueChange={(values,suorceInfo)=>{
                                   setVenda(values.value);
                                 }} 
                            />     
              </div>

              <div className="col-1">
                  <label htmlFor="inputAddress" className="form-label">QTD RESULTADO</label>
                  <NumericFormat className="form-control"
                                 id="inputCompra" 
                                 value={qtdProduzida.toLocaleString("pt-br", {style:"currency", currency:"BRL"})}
                                 tabIndex="8"
                                 allowLeadingZeros
                                 decimalSeparator=','
                                 thousandSeparator='.'
                                 decimalScale={3}
                                 onValueChange={(values,suorceInfo)=>{
                                   setQtdProduzida(values.value);
                                 }} 
                            />     
              </div>  

               <div className="col-1">
                  <label htmlFor="inputAddress" className="form-label">LUCRO</label>
                  <NumericFormat className="form-control"
                                 id="inputCompra" 
                                 value={lucroReal.toLocaleString("pt-br", {style:"currency", currency:"BRL"})}
                                 tabIndex="8"
                                 allowLeadingZeros
                                 decimalSeparator=','
                                 thousandSeparator='.'                                 
                                 suffix="%"
                                 onValueChange={(values,suorceInfo)=>{
                                   setLucroReal(values.value);
                                 }} 
                                 readOnly
                            />     
              </div>      

              <div className="col-2 mt-3 ">
              <button
                type="button"
                className="btn btn-primary"
                onClick={abreCalculaVenda}
              >
                <i className="bi bi-calculator-fill"></i>
                Calcular Venda
              </button>
            </div> 

           


              <h3 className="mt-3">Adicione os componentes</h3>

              <hr />
              <div className="row">
              <div className="col-2">
              <label htmlFor="inputQuantidadeComponente" className="form-label">CODIGO</label>
              <div className="input-group">
              <input
                type="number"
                value={codigoProd}
                onChange={(e) => setCodigoProd(e.target.value)}
                className="form-control"
                id="inputQuantidadeComponente"
                tabIndex="3"
                readOnly
              />
               <button
                type="button"
                className="btn btn-primary "
                onClick={openModalProduto}
                id="button-addon2"
                
              >
                <i className="bi bi-search"></i>
                
              </button>
              </div>
            </div>

              <div className="col-3">
              <label htmlFor="inputDescricaoComponente" className="form-label">DESCRICAO</label>
              <input
                type="text"
                value={descricaoComponente}
                onChange={(e) => setDescricaoComponente(e.target.value)}
                className="form-control"
                id="inputDescricaoComponente"
                tabIndex="2"
                autoComplete="off"
                readOnly
              />
            </div>

            <div className="col-1">
              <label htmlFor="inputDescricaoComponente" className="form-label">QUANTIDADE</label>
              <input
                type="number"
                value={quantidade}
                onChange={(e) => setQuantidade(e.target.value)}
                className="form-control"
                id="inputDescricaoComponente"
                tabIndex="2"
                autoComplete="off"
                
              />
            </div>

            <div className="col-1">
                  <label htmlFor="inputAddress" className="form-label">VENDA</label>
                  <NumericFormat className="form-control"
                                 id="inputCompra" 
                                 value={compraComponente.toLocaleString("pt-br", {style:"currency", currency:"BRL"})}
                                 tabIndex="8"
                                 allowLeadingZeros
                                 readOnly
                                 decimalSeparator=','
                                 thousandSeparator='.'
                                 decimalScale={2}
                                 prefix="R$ "
                                 onValueChange={(values,suorceInfo)=>{
                                   setCompraComponente(values.value);
                                 }} 
                            />     
              </div>

              <div className="col-1">
                  <label htmlFor="inputAddress" className="form-label">CUSTO</label>
                  <NumericFormat className="form-control"
                                 id="inputCompra" 
                                 value={custo.toLocaleString("pt-br", {style:"currency", currency:"BRL"})}
                                 tabIndex="8"
                                 allowLeadingZeros
                                 readOnly
                                 decimalSeparator=','
                                 thousandSeparator='.'
                                 decimalScale={2}
                                 prefix="R$ "
                                 onValueChange={(values,suorceInfo)=>{
                                   setCusto(values.value);
                                 }} 
                            />     
              </div>
            
            
            
            

            <div className="col-2 mt-3 ">
              <button
                type="button"
                className="btn btn-primary"
                onClick={adicionarComponente}
              >
                <i className="bi bi-plus-circle-fill"></i>
                Componente
              </button>
            </div> 

            <div className="col-2 mt-3 ">
              <button
                type="button"
                className="btn btn-primary"
                onClick={abreCalculaCusto}
              >
                <i className="bi bi-calculator-fill"></i>
                Calcular Custo
              </button>
            </div> 

            </div>


          



  
              {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
              {sucesso === 'S' ? <Navigate to='/app/fichaTecnica' /> : null}
  
              </form> 

              <div className="mt-4">
            <h4>Componentes Adicionados</h4>
            <table  id='table-prod' className="table table-hover table-striped"> 
              <thead>
                <tr>
                   <th scope="col">Codigo</th>
                   <th scope="col">Descricao</th>
                   <th scope="col">Quantidade</th>
                   <th scope="col">VENDA</th>
                   <th scope="col">Custo</th>
                   <th scope="col">Ação</th>
                </tr>
                </thead>
                <tbody className="table-group-divider">
                  {componentes.map((componente) => (
                    <tr key={componente.CODIGO}>
                      <td >{componente.CODIGO}</td>
                      <td>{componente.DESCRICAO}</td>
                      <td>{componente.QUANTIDADE}</td>
                      <td>{componente.COMPRACOMPONENTE}</td>
                      <td>{componente.CUSTOCOMPONENTE}</td>
                      <td className="text-center">
                      <button
                        onClick={() => confirmaId(componente.CODIGO)}
                        className="btn btn-danger" >
                        <i className="bi bi-trash-fill"></i>
                       </button>
                      </td>
                    </tr>
                    
                  ))}
                </tbody>
              

            </table>

{/*             
            {componentes.length > 0 ? (
              <ul className="list-group">
                {componentes.map((componente, index) => (
                  <li key={index} className="list-group-item">
                    <strong>Codigo:</strong> {componente.codigo} | <strong>Descrição:</strong> {componente.descricao} | <strong>Quantidade:</strong> {componente.quantidade} 
                  </li>
                ))}
              </ul>
            ) : (
              <p>Nenhum componente adicionado</p>
            )} */}
          </div>

          <hr />

          <div class="mb-3 mt-3">
            <label for="observacao" class="form-label">MODO DE PREPARO</label>
            <textarea class="form-control" id="observacao" rows="5" value={preparo} onChange={(e) => setPreparo(e.target.value)} placeholder="Digite as instruções aqui..."></textarea>
            </div> 

          <div className="col-12 mb-5">
              
                  <Link to="/app/fichaTecnica" type="submit" className="btn btn-outline-primary butao"  tabIndex="14">Desistir</Link>
                  {tag != '0'?(
                             <button type="button" className="btn btn-primary butao" onClick={salvaFicha} tabIndex="13">Salvar</button>
                             ):null}

              </div>

       </div>
       {
      erroValidacao ? 
      <SweetAlert
         danger
         confirmBtnText="OK"
         confirmBtnBsStyle="danger"
         title="Erro"
         onConfirm={() => setErrovalidacao(false)}                            
       >
         {msgErro}
       </SweetAlert>:null
      
     }

{
      calculaVenda ? 
      <SweetAlert
         primary
         showCancel
         confirmBtnText="OK"
         confirmBtnBsStyle="primary"
         title="Calculo de custo"
         onConfirm={atualizaVenda}  
         onCancel={fechaCalculaVenda}                          
       >
         {`O valor de venda recomendado é de ${novaVenda}, deseja atualizar o valor de venda do produto com o valor atualizado?`}
       </SweetAlert>:null
      
     }

{
      calculaCusto ? 
      <SweetAlert
         primary
         showCancel
         confirmBtnText="OK"
         confirmBtnBsStyle="primary"
         title="Calculo de custo"
         onConfirm={atualizaCompra}  
         onCancel={fechaCalculaCusto}                          
       >
         {`O custo do produto é de ${novoPreco}, deseja atualizar o valor de compra do produto com o valor atualizado?`}
       </SweetAlert>:null
      
     }

      {
                confirmacao ? 
                <SweetAlert
                   warning
                   showCancel
                   showCloseButton
                   confirmBtnText="Sim"
                   confirmBtnBsStyle="danger"
                   cancelBtnText="Não"
                   cancelBtnBsStyle='ligth'
                   title="Atenção"
                   onConfirm={deletaComponente}
                   onCancel={() => setConfirmacao(false)}
                   focusCancelBtn
                   reverseButtons
                 >
                   Deseja excluir Este Componente?
                 </SweetAlert>:null
                
               }
   </div>  
   <FooterBar/>
</div>
};

export default NovaFichaTecnica;